import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
    ContactMechanisms,
    GEOGRAPHICAL_REGIONS,
    Grade,
    POSTAL_ADDRESSES,
    School,
    SCHOOL_PROPERTY_TYPE,
    SCHOOL_STATUS,
    SCHOOL_STATUS_TYPE,
    SCHOOL_TYPE
} from 'src/app/model/school.model'; // PartyContactMechanisms,
import { Component, Inject, OnInit, OnDestroy, ElementRef, ViewChild, EventEmitter, Output, AfterViewInit, HostListener } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, FormGroupDirective, NgForm, ValidationErrors } from '@angular/forms';
import { QuestionHelpText } from 'src/app/model/question-help-text';

import { PARTYROLE, Region } from 'src/app/model/region.model';
import { County } from '../../../model/county';
import { AppState } from 'src/app/reducers';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { DistrictEntityService } from 'src/app/component/common-components/service/district-entity.service';
import { CountyEntityService } from 'src/app/component/common-components/service/county-entity.service';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { UserProfileService } from '../../user-profile/service/user-profile.service';
import { User } from '../../auth/model/user.model';
import { ApiSchoolsService } from 'src/app/service/api-schools.service';
import { OrganizationService } from '../../common-components/organizations/service/organization.service';
import { ORGANIZATION } from 'src/app/model/school.model';
import { Observable, Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { HelperService } from 'src/app/service/helper.service';
import { Store } from '@ngrx/store';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { DatePipe } from '@angular/common';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { PartyContactMechanisms } from '../../party/model/party-contact-mechanisms.model';
import { RegionEntityService } from '../../common-components/service/region-entity.service';
import { MatCalendar } from '@angular/material/datepicker';
import { CustomDatepickerComponent } from '../../common-components/custom-datepicker/custom-datepicker.component';
import { UtilityService } from 'src/app/service/utility.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DistrictDropdownTwoWayComponent } from '../../common-components/district/district-dropdown-two-way/district-dropdown-two-way.component';
import { RegionDropdownTwoWayComponent } from '../../common-components/region/region-dropdown-two-way/region-dropdown-two-way.component';
import { CountyDropdownTwoWayComponent } from '../../common-components/county/county-dropdown-two-way/county-dropdown-two-way.component';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
    parse: {
        dateInput: 'LL'
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};

@Component({
    selector: 'app-edit-school',
    templateUrl: './edit-school.component.html',
    styleUrls: ['./edit-school.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },

        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})
export class EditSchoolComponent implements AfterViewInit, OnInit, OnDestroy, ErrorStateMatcher {
    @ViewChild('child') child!: DistrictDropdownTwoWayComponent;
    @ViewChild('child2') child2!: RegionDropdownTwoWayComponent;
    @ViewChild('child3') child3!: CountyDropdownTwoWayComponent;
    @ViewChild('ssid') fieldSSID!: ElementRef;
    @ViewChild('tabGroup') tabGroup: any;
    @ViewChild('calendar') calendar: MatCalendar<Moment>;
    @Output() eventEmitterDistrictcode = new EventEmitter<SchoolDistrict[]>();
    @Output() eventEmitterCountycode = new EventEmitter<County[]>();
    @Output() eventEmitterRegioncode = new EventEmitter<Region[]>();

    @Output() btnClick = new EventEmitter(); // to disable school code buttons when not in edit mode
    @Output() btnClick2 = new EventEmitter(); // to disable school code buttons when not in edit mode

    selected = new UntypedFormControl('valid', [Validators.required, Validators.pattern('valid')]);
    selectedTab = new UntypedFormControl(0);
    customRegionLabel = "School's Region *";
    customCountyLabel = "School's County *";
    customDistrictLabel = "School's District *";
    formCtrl = new UntypedFormControl();
    myForm = new UntypedFormArray([new UntypedFormControl('', Validators.required)]);
    schoolDistrictNcesFC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(7)]));
    schoolNameFC = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])); //
    txtStreet1 = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])); //
    txtStreet2 = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])); //
    txtCity = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])); //
    txtZip = new UntypedFormControl('', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(100)])); //

    txtFirstName = new UntypedFormControl('', Validators.compose([Validators.minLength(1), Validators.maxLength(100)]));
    txtLastName = new UntypedFormControl('', Validators.compose([Validators.minLength(1), Validators.maxLength(100)]));
    txtPhoneNumber = new UntypedFormControl('', Validators.compose([Validators.minLength(1), Validators.maxLength(100)]));
    txtEmail = new UntypedFormControl('', Validators.compose([Validators.minLength(1), Validators.maxLength(100)]));

    bDisableCreateButton: boolean = false;
    bDisableCreateButton2: boolean = false;
    bDisableCreateButton3: boolean = false;

    selectLabel1: string = 'Select Region(s)';
    selectLabel2: string = 'Select County(s)';
    selectLabel3: string = 'Select School District(s)';
    region!: Region;
    regionCap!: Region;
    district!: SchoolDistrict;
    districts = [];
    resetField: boolean = false;
    selectedCounty: number | undefined;
    myCounty: County;
    myCounties: County[] = [];
    newNumArray: number[] = [];
    myRegions: Region;
    selectedSchoolDistrict: number = 0;
    selectedDistrict: number | undefined;
    schoolDistricts: SchoolDistrict[] = [];
    allSchoolDistricts: SchoolDistrict[] = [];
    allSchoolCounties: County[] = [];
    allSchoolRegions: Region[] = [];
    schoolRegionIds: number[] = [];
    schoolDistrictIds: number[] = [];
    selectedSchoolDistrictIds: number[] = [];
    selectedSchoolDistrictName: string | undefined;

	chosenRegions: Region[] = [];
	chosenCounties: County[] = [];
	chosenSchoolDistricts: SchoolDistrict[] = [];

    isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        const isSubmitted = form && form.submitted;
        return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
    selectFormControl = new UntypedFormControl('valid', [Validators.required, Validators.pattern('valid')]);

    nativeSelectFormControl = new UntypedFormControl('valid', [Validators.required, Validators.pattern('valid')]);

    matcher = this;
    serializedDate: any;
    newTestDate: UntypedFormControl;
    cleanedCreatedDate: UntypedFormControl;
    events: string[] = []; // this is for date events
    selectedDate: Moment;
    saveButtonToShow: string = 'generalinfo'; // choices are: generalinfo, contactinfo, schoollocation
    editBtnText: string = 'Edit';
    isUneditable: boolean = true;
    bCancelEdit: boolean = false;
    schoolID: number = 0;
    schoolTypeID: number = 0;
    schoolPropertyTypesID: number = 0;
    schoolPropertyID: number = 2; // 2 is default here
    schoolStatusId: number = 1;
    thisSchoolStatus: number = 1;
    CDSCode: string = '';
    closedDate?: string = '';
    gradeSpanHigh: number = 0;
    gradeSpanLow: number = 0;
    gradesTable: number[];
    gradeItems: Grade[];
    selectedLowGradeItem: string = '';
    selectedHighGradeItem: string = '';
    subTypeItems: SCHOOL_TYPE[];
    bDisAllowSubTypes: boolean = true;
    bAllowSC: boolean = false;
    selectedSubTypeItem: number;
    iToggleSCValid1: number = 0;
    iToggleSCValid2: number = 0;
    iToggleSCValid3: number = 0;
    bCheckedSCCode1: boolean = false;
    bCheckedSCCode2: boolean = false;
    bCheckedSCCode3: boolean = false;

    radioOptionsSchoolType: any = [
        {
            id: 1,
            name: 'Public',
            checked: false,
            fnToCall: 'fnTogglePublicOrPrivateSubTypes()'
        },
        {
            id: 2,
            name: 'Private',
            checked: false,
            fnToCall: 'fnTogglePublicOrPrivateSubTypes()'
        },
        {
            id: 3,
            name: 'Other',
            checked: false,
            fnToCall: 'fnToggleSubTypes()'
        }
    ];

    radioOptionsSchoolStatus: any = [
        {
            id: 1,
            name: 'Open',
            checked: false,
            fnToCall: 'fnToggleOpenOrClosedStatus()'
        },
        {
            id: 2,
            name: 'Closed / Merged',
            checked: false,
            fnToCall: 'fnToggleOpenOrClosedStatus()'
        }
    ];

    selectedRegion: string = '';
    NCES: string = '';
    districtNCES: string = '';
    selectedNcesCode: string = '';
    schoolDistrictNCES: string = '';
    user: User = {};
    partyRoles: PARTYROLE[] = [];
    regions: Region[] = [];
    userIdChanged: boolean = false;

    partyContactMechanisms: PartyContactMechanisms[] = [];
    deletePartyContactMechanisms: PartyContactMechanisms[] = [];
    isEditingPartyContactMechanisms: Event; //boolean = false;

    suffixes: string[] = ['Jr', 'Sr', 'II', 'III', 'IV', 'V', 'VI'];

    isLoading: boolean = false;
    loadingCounter: number = 0;
    isDone: boolean = false;
    msg: MsgModel = {};
    userIdChangedMsg: MsgModel = {};

    // init checks
    validGrades: boolean = false;
    scValid: boolean = false; // not valid would include blank or invalid
    ngChecking: boolean = false;
    ngChecked: boolean = true;
    ngValid: boolean = true;
    ncesValid: boolean = false;
    ncesChecking: boolean = false;
    ncesChecked: boolean = false;

    // auth
    canEditSchoolNCES: boolean = false;
    promises: Array<any> = [];

    myControl: any;
    filteredOptions!: Observable<any>;
    private unsubUsername$: Subject<void> = new Subject<void>();
    myError: string = '';
    myGradeError: string = '';
    myCloseDateError: string = '';
    editSchoolsForm!: UntypedFormGroup;
    organizationService!: OrganizationService;
    school: School;
    schoolBackup: School;
    lstQuestionHelpText: QuestionHelpText[] = [];
    schoolName: string = '';
    schoolCode: number = 0;
    schoolStatus: number = 1;
    satelliteCampus: boolean = false;
    myPropType: SCHOOL_PROPERTY_TYPE;
    mySchoolStatus: SCHOOL_STATUS;
    indeterminate: boolean = false;
    schoolType: number = 0;
    SSID: string = '';
    partyId: any = [{}];
    organizationId!: number;
    myOrganization!: ORGANIZATION;
    partyIdNum!: number;
    loadedDistricts$: Observable<boolean>;
    loadedCounties$: Observable<boolean>;

    // backup components
    currentTab: any;
    tabs = [
        {
            'General Info': {
                editing: false,
                control: {},
                editable: true
            },
            'Contact Info': {
                editing: false,
                control: {},
                editable: true
            },
            'School Location': {
                editing: false,
                control: {},
                editable: true
            }
        }
    ];

    constructor(
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<EditSchoolComponent>,
        @Inject(MAT_DIALOG_DATA) public editData: any,
        private fb: UntypedFormBuilder,
        private userProfileService: UserProfileService,
        private schoolAPIService: ApiSchoolsService,
        private _organizationService: OrganizationService,
        private schoolDistrictService: DistrictEntityService,
        private schoolCountyService: CountyEntityService,
        private schoolRegionService: RegionEntityService,
        private store: Store<AppState>,
        private router: Router,
        private helperService: HelperService,
        private utilityService: UtilityService,
        private datePipe: DatePipe
    ) {
        this.organizationService = _organizationService;
        this.editSchoolsForm = fb.group({
            schoolNameFC: ['', [Validators.required]],
            schoolSSID: ['', null],
            cdsCode: ['', [Validators.required]],
            schoolNCES: ['', null],
            radioSchoolType: ['', [Validators.required]],
            radioSchoolStatus: ['', [Validators.required]],
            frmCloseDate: new UntypedFormControl(null),
            selectSubType: new UntypedFormControl(null),
            selectLowGrade: ['valid', [Validators.required, Validators.pattern('valid')]],
            selectHighGrade: ['valid', [Validators.required, Validators.pattern('valid')]],
            txtSchoolCode: new UntypedFormControl(null),
            chkSatelliteCampus: new UntypedFormControl(null),

            // tab 3 fields
            schoolDistrictNCES: new UntypedFormControl(null)
        });

        this.schoolID = this.editData['ID'];
        this.isLoading = true;
        this.loadingCounter = this.loadingCounter + 1;
        this.loadedDistricts$ = schoolDistrictService.loaded$;
        this.loadedCounties$ = schoolCountyService.loaded$;
        this.subscribers();
        this.fnEdit();

    }

    fnParseCDSCode(partNum: number, inCDSCode: string): string {
        let strRet: string = '';
        switch (partNum) {
            case 1:
                try {
                    strRet = inCDSCode.substring(0, 2);
                } catch (Err) {}
                break;
            case 2:
                try {
                    strRet = inCDSCode.substring(2, 7);
                } catch (Err) {}
                break;
            case 3:
                try {
                    strRet = inCDSCode.substring(8, 15);
                } catch (Err) {}
                break;
        }
        console.log('fnParseCDSCode returning: ' + strRet);
        return strRet;
    }

    subscribers() {
        let schoolRegionsEntitiesSub = this.schoolRegionService.entities$.subscribe((schoolRegions: Region[]) => {
            this.allSchoolRegions = schoolRegions;
            this.schoolRegionIds = this.allSchoolRegions.length > 0 ? this.allSchoolRegions.map((schoolRegion) => schoolRegion.ID!) : [];
        });

        let schoolDistrictEntitiesSub = this.schoolDistrictService.entities$.subscribe((schoolDistricts: SchoolDistrict[]) => {
            this.allSchoolDistricts = schoolDistricts;
            this.schoolDistrictIds = this.allSchoolDistricts.length > 0 ? this.allSchoolDistricts.map((schoolDistrict) => schoolDistrict.ID!) : [];
        });

        let schoolCountyEntitiesSub = this.schoolCountyService.entities$.subscribe((schoolCounties: County[]) => {
            this.allSchoolCounties = schoolCounties;
        });
    }

    ngOnInit(): void {
        console.log("ngOnInit called")
        // reinit these starter booleans
        this.validGrades = false;
        this.scValid = false; // not valid would include blank or invalid
        this.ngChecking = false;
        this.ngChecked = true;
        this.ngValid = true;
        this.ncesValid = false;
        this.ncesChecked = false;
        this.ncesChecking = false;

        this.getUserProfile();

        Promise.all(this.promises).then((res) => {
            this.getPartyRoles();
            ///    this.getRegionsByPartyId();
        });

        // auth - check if allow the user admin operations
        this.fnCheckCanEditSchoolNCES();
    }

    ngAfterViewInit(): void {
        console.log("ngAfterViewInit called")
        // set school data
        //setTimeout(() => {
        //   console.log("now calling fnsetinitialdata")
        this.fnSetInitialData();
        //});
        // }, 5000);

        // load party data
        this.organizationId = this.editData['ORGANIZATIONS_ID'];
        this._organizationService.show(this.organizationId).subscribe({
            next: (res: any) => {
                this.myOrganization = res.organization;
                console.log('organization is: ' + Object.entries(this.myOrganization));
                console.log('party ids are: ' + this.myOrganization.PARTIES_ID);
                this.partyId = this.myOrganization.PARTIES_ID;
                this.partyIdNum = parseInt(this.partyId);
                console.log('inbound organization id1 is: ' + this.organizationId);
                console.log('my organization: ' + this.myOrganization.PARTIES_ID);
            },
            error: (err: any) => {
                alert('Error while fetching the records');
                console.log('error while getting organization data');
            }
        });

        /*  console.log("schoolPropertyId:" + this.schoolPropertyID);
        console.log("schoolStatusId:" + this.schoolStatusId);*/
        console.log('closedDate:' + this.closedDate);
        //console.log("ssid:" + this.SSID);
        //console.log("gradelow:" + this.gradeSpanLow);
        //console.log("gradehigh:" + this.gradeSpanHigh);
        //console.log("nces:" + this.NCES);
        //console.log("schoolCode:" + this.schoolCode);
        //console.log("editdata:" + Object.entries(this.editData))

        this.editSchoolsForm = new UntypedFormGroup({
            schoolNameFC: new UntypedFormControl(null),
            schoolSSID: new UntypedFormControl(null),
            cdsCode: new UntypedFormControl(null),
            schoolNCES: new UntypedFormControl(null),
            radioSchoolStatus: new UntypedFormControl(null),
            radioSchoolType: new UntypedFormControl(null),
            selectSubType: new UntypedFormControl({ value: '', disabled: true }), //
            selectLowGrade: new UntypedFormControl({ value: '', disabled: true }), // {value:'', disabled: true}
            selectHighGrade: new UntypedFormControl({ value: '', disabled: true }), //{value:'', disabled: true}
            txtSchoolCode: new UntypedFormControl(null),
            chkSatelliteCampus: new UntypedFormControl(null),
            frmCloseDate: new UntypedFormControl(null),
            // tab 2 fields

            // tab 3 fields
            myRegion: new UntypedFormControl(null),
            myDistrict: new UntypedFormControl(null),
            myCounty: new UntypedFormControl(null),
            schoolDistrictNCES: new UntypedFormControl(null)
        });
    }

    getSchool(thisSchoolId: number) {
        console.log('passing in schoolid:' + thisSchoolId);
        this.schoolAPIService.show(thisSchoolId).subscribe((res) => {
            console.log('thisSchool: ');
            this.school = res.school;
            console.log(this.school);

            this.newTestDate = new UntypedFormControl(moment());
            console.log('newTestDate from getSchool:' + Object.entries(this.newTestDate));

            console.log('now parsing closedDate');
            this.closedDate = new CleanDatePipe().transform(this.school.CLOSE_DATE);
            console.log('parsed closedDate');
            if (this.closedDate) {
                var cleanDate = new Date(this.closedDate);
                console.log('my closed date from : ');
                console.log(cleanDate?.getTime());
                if (
                    cleanDate.getTime() == 31 ||
                    cleanDate.getTime() == -2208988800000 ||
                    cleanDate.getTime() == -62135596800000 ||
                    cleanDate.getTime().toString() == 'NaN'
                ) {
                    // invalid date
                    console.log('found an invalid date for datepicker');
                    console.log(cleanDate.getTime());
                    this.closedDate = '';
                } else {
                    this.newTestDate = new UntypedFormControl(moment([cleanDate.getFullYear(), cleanDate.getMonth(), cleanDate.getDay()])); // .setValue(cleanDate);
                    console.log('newTestDate from getSchool is now:' + Object.entries(this.newTestDate));
                }
            }
        });
    }

    districtsSelected(districts: SchoolDistrict[]) {
        var editDistrict: any;

        if (districts[0] && this.child3.selectedCountyName != undefined) {
            editDistrict = this.getSpecificDistrict(districts[0].ID);
            this.school.SCHOOL_DISTRICT = editDistrict;
            this.selectedNcesCode = this.school.SCHOOL_DISTRICT.NCESDist.toString();
            this.schoolDistrictNCES = this.selectedNcesCode;
        }
    }

    countiesSelected(counties: County[]) {
        this.eventEmitterCountycode.emit(counties);
        this.schoolDistrictNCES = '';
        this.selectedNcesCode = '';
    }

    regionEventEmitter(lstRegion: Region[]) {
        this.loadingCounter = this.loadingCounter + 1;
        if (this.loadingCounter > 2 && this.child3.selectedCountyName == undefined) {
            this.selectedSchoolDistrict = 0;
        }
        this.schoolDistrictNCES = '';
        this.selectedNcesCode = '';
    }

    // edit-contact-mechanisms functions
    partyContactMechanismsChange(update: any) {
        console.log('now calling bad partyContactMechanismsChange');
        /* this.partyContactMechanisms = update.partyContactMechanisms;
     this.deletePartyContactMechanisms = update.deletePartyContactMechanisms;
 */
        console.log('partyContactMechanismsChange', update);
    }

    fnCancelEdit() {
        this.bCancelEdit = !this.bCancelEdit;
        Swal.fire({
            title: 'Are you sure you want to stop editing and discard all changes made?',
            showDenyButton: true,
            showConfirmButton: false,
            showCancelButton: true,
            denyButtonText: `Confirm`
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info');
                this.isUneditable = !this.isUneditable;
                if (this.isUneditable) this.bAllowSC = false;
                this.editBtnText = 'Edit';
                this.fnReset();
            }
        });
    }

    fnEdit() {
        this.myError = '';
        this.isUneditable = !this.isUneditable;
        if (this.isUneditable) this.bAllowSC = false;
        if (!this.isUneditable) {
            this.editBtnText = 'Editing...';
            this.bCancelEdit = true;
            this.bAllowSC = true;

            this.schoolBackup = { ...this.school };
            console.log(this.schoolBackup);
            console.log('is the backup just saved');
        } else {
            console.log('now entering edit only block');
            this.bCancelEdit = false;
            this.editBtnText = 'Edit';
            this.bAllowSC = false;
        }
    }

    fnSetInitialData() {
        console.log('setting initial school data');
        const districtShell = this.editData['SCHOOL_DISTRICT'];

        const districtOrganization = districtShell['Organization'];
        if (districtOrganization) {
            console.log('OrganizationDistrict:' + Object.entries(districtOrganization));
        }
        this.schoolID = this.editData['ID'];

        this.schoolAPIService.show(this.schoolID).subscribe((res) => {
            console.log('thisSchool: ');
            this.school = res.school;
            console.log(this.school);
            this.schoolBackup = { ...this.school };

            this.chosenRegions = [];
            let newRegion = new Region();
            newRegion.ID = this.school.REGIONS.ID;
            this.chosenRegions.push(newRegion);

            this.chosenCounties = [];
            let newCounty = new County();
            newCounty.ID = this.school.COUNTy.ID;
            this.chosenCounties.push(newCounty);

			this.chosenSchoolDistricts = [];
			let newSchoolDistrict = new SchoolDistrict();
			newSchoolDistrict.ID = this.school.SCHOOL_DISTRICT.ID;
			this.chosenSchoolDistricts.push(newSchoolDistrict);

            this.selectedDistrict = this.school.SCHOOL_DISTRICT.ID!;
            this.selectedSchoolDistrict = this.school.SCHOOL_DISTRICT.ID!;
            this.schoolPropertyID = this.editData['SCHOOL_PROPERTY_TYPES.ID'];

            if (!this.schoolPropertyID) {
                this.schoolPropertyID = 2;
            }
            this.schoolDistrictNCES = this.school.SCHOOL_DISTRICT.NCESDist.toString() || '';
            this.selectedNcesCode = this.school.SCHOOL_DISTRICT.NCESDist.toString() || '';
            this.schoolName = this.school.NAME;
            this.SSID = this.school.SSID;
            this.schoolType = this.school.SCHOOL_TYPE_ID;
            this.myPropType = this.school.SCHOOL_PROPERTY_TYPES;

            if (this.myPropType?.ID) {
                if (this.myPropType?.ID == 1) {
                    this.satelliteCampus = true;
                } else {
                    this.satelliteCampus = false;
                }
            }

            this.CDSCode = this.school.cdscODE;
            this.NCES = this.school.SCHOOL_NCES;
            this.schoolCode = this.school.SCHOOL_CODE;
            this.gradeSpanLow = this.school.LOW_GRADE;
            this.gradeSpanHigh = this.school.HIGH_GRADE;
            this.selectedHighGradeItem = this.gradeSpanHigh.toString();
            this.selectedLowGradeItem = this.gradeSpanLow.toString();
            //const getTypeOthers: SCHOOL_TYPE = this.school.SCHOOL_TYPE_OTHERS;
            this.schoolType = this.school.SCHOOL_TYPE_ID;
            switch (this.schoolType) {
                case 1:
                    this.bCheckedSCCode1 = true;
                    break;
                case 2:
                    this.bCheckedSCCode2 = true;
                    break;
                case 3:
                    this.bCheckedSCCode3 = true;
                    break;
            }

            this.mySchoolStatus = this.school?.SCHOOL_STATUS;
            if (this.mySchoolStatus) {
                this.schoolStatus = this.mySchoolStatus.SCHOOL_STATUS_TYPES_ID;
            }

            if (this.mySchoolStatus) {
                this.closedDate = this.mySchoolStatus.CLOSE_DATE ? new CleanDatePipe().transform(this.mySchoolStatus.CLOSE_DATE) 
                : '';  // this.editData['CLOSE_DATE'];
                
                const formattedDate = this.datePipe.transform(this.closedDate, 'MM/dd/yyyy');
                this.closedDate = formattedDate || '';
                console.log('closedDate initially taken as:' + this.closedDate);
                if (this.closedDate) {
                    this.newTestDate = new UntypedFormControl(); //moment()
                    console.log('newTestDate:' + Object.entries(this.newTestDate));

                    var cleanDate = new Date(this.closedDate);
                    console.log('date moment check');
                    var dateMomentCheck = cleanDate?.getFullYear() + '-' + cleanDate?.getMonth() + '-' + cleanDate?.getDate();
                    console.log(dateMomentCheck);
                    console.log('closed date from : ' + cleanDate.getTime());
                    console.log('closed date from : ' + cleanDate.getDate());
                    if (dateMomentCheck == '1899-11-31' || cleanDate.getTime() == -62135596800000 || cleanDate.getTime().toString() == 'NaN') {
                        // invalid date
                        console.log('blanking out closedDate on an invalid date');
                        this.closedDate = '';
                        if (this.schoolStatus != 2) {
                            this.schoolStatus = 1; // because there was no closed date, school status should display as Open
                            this.schoolStatusId = 1;
                            this.mySchoolStatus.ID = 1;
                        }
                    } else {
                        console.log('closeddate was seen as valid!');
                        var tmpDate: UntypedFormControl = new UntypedFormControl(
                            moment([cleanDate.getFullYear(), cleanDate.getMonth(), cleanDate.getDate()])
                          );
                          
                          this.newTestDate = tmpDate ? new UntypedFormControl(new CleanDatePipe().transform(tmpDate.value)) : new UntypedFormControl('');
                        // .setValue(cleanDate);
/*                        this.closedDate = result.myResult ? new CleanDatePipe().transform(result.myResult) 
                        moment([cleanDate.getFullYear(), cleanDate.getMonth(), cleanDate.getDate()])
                        : '';         */
                        console.log('newTestDate is now:' + Object.entries(this.newTestDate));
                        this.schoolStatus = 2; // because there was a closed date, school status should display as Closed/Merged
                        this.schoolStatusId = 2;
                        this.mySchoolStatus.ID = 2;
                    }
                }
            }

            var translateCounty = Object.values(this.editData['COUNTy']).toString().split(',');

            this.isLoading = false;

            this.fnCheckNCESDistrictCode();

            // backup for screenBackup save functionality
            /*this.schoolBackup = JSON.parse(JSON.stringify(this.school));
      console.log("new backup set for school");
      console.log(this.schoolBackup);
      */
        });

        this.organizationService.getGradesTable().subscribe({
            next: (res: any) => {
                this.gradeItems = res.grades;
            },
            error: (err: any) => {
                console.log('error getting grades:' + Object.entries(err));
            }
        });

        this.schoolAPIService.getOtherSubtypes().subscribe({
            next: (res: any) => {
                this.subTypeItems = res.schoolTypeOthers;
            },
            error: (err: any) => {
                console.log('error getting otherSubTypes:' + Object.entries(err));
            }
        });

        this.schoolAPIService.getSchoolStatus().subscribe({
            next: (res: any) => {
                // this.subTypeItems = res.schoolTypeOthers;
            },
            error: (err: any) => {
                console.log('error getting school statuses:' + Object.entries(err));
            }
        });
    }

    fnReset() {
        setTimeout(() => {
            this.fnSetInitialData();
        }, 1000);
    }

    getPartyRoles() {
        console.log('getting party roles for user:' + Object.entries(this.user));
        this.userProfileService.getPartyRoles(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.partyRoles) {
                this.partyRoles = res.partyRoles;
                console.log('got party roles:' + res.partyRoles);
            }
        });
    }

    getRegionsByPartyId() {
        this.userProfileService.getRegionsByPartyId(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.regions) {
                this.regions = res.regions;
            }
        });
    }

    // for Auth
    fnCheckCanEditSchoolNCES() {
        // until sec roles have been implemented, we will set this as true
        this.canEditSchoolNCES = true;
    }

    validateClosedDate() {
        let inCloseDate: string = this.editSchoolsForm.controls['frmCloseDate'].value || this.closedDate;
        console.log('inCloseDate came in as: ' + inCloseDate);
        if ((inCloseDate == null || inCloseDate == '') && this.schoolStatus != 1) {
            this.myError = 'There are missing fields. Please check your input.';
            this.myCloseDateError = 'Close Date is required.';
        } else {
            this.myCloseDateError = '';
            this.myError = '';
        }
        return inCloseDate;
    }

    fnValidateGrades() {
        this.validateGrades();
        return this.validGrades;
    }

    validateGrades() {
        let iLowGrade: number = this.gradeSpanLow;
        let iHighGrade: number = this.gradeSpanHigh;

        if (iLowGrade > 0 && iHighGrade > 0) {
            if (iLowGrade > iHighGrade) {
                this.myGradeError = 'Low grade cannot be greater than high grade.';
                this.validGrades = false;
            } else {
                this.validGrades = true;
            }
        } else {
            this.validGrades = true;
        }

        return this.validGrades;
    }

    catchSubmitError(err: any) {
        console.log('submit edits caught error:' + err);
        this.myError = 'Error during submit:' + err;
    }

    checkSchoolCode(evt: any) {
        if (!this.bAllowSC) {
            evt.preventDefault();
        } else if (!this.isUneditable) {
            this.myError = '';
            this.ngChecking = true;
            this.fnTogglePublicOrPrivateSubTypes();
        }
    }

    closeRecord() {
        if (this.isUneditable) {
            this.dialogRef.close();
        } else {
            Swal.fire({
                title: 'Are you sure you want to stop editing and discard all changes made?',
                showDenyButton: true,
                showConfirmButton: false,
                showCancelButton: true,
                denyButtonText: `Confirm`
            }).then((result) => {
                if (result.isDenied) {
                    Swal.fire('Changes are not saved', '', 'info');
                    this.editBtnText = 'Edit';
                    this.fnReset();
                    this.dialogRef.close();
                }
                if (result.isConfirmed) {
                    this.dialogRef.close();
                } else {
                    // do nothing except close popup swal confirmation
                }
            });
        }
    }

    displayHelpText(qId: number) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = true;
        dialogConfig.maxHeight = '80vh';
        dialogConfig.data = this.returnHelpText(qId);
        /// const dialogRef = this.dialog.open(HelpTextComponent, dialogConfig);
    }

    returnHelpText(qId: number): string {
        let questionHelpText = this.lstQuestionHelpText.find((x) => x.QUESTIONS_ID == qId);

        if (questionHelpText) return questionHelpText?.HELP_TEXT;
        else return '';
    }

    ngOnDestroy(): void {
        this.unsubUsername$.next();
        this.unsubUsername$.complete();
    }

    getUserProfile() {
        let deferred = new Promise((resolve, reject) => {
            this.userProfileService.getMyProfile().subscribe((res) => {
                if (res?.user) {
                    this.user = res.user;

                    resolve(res);
                } else if (res?.msg) {
                    reject(res);
                } else {
                    reject('err');
                }
            });
        });
        this.promises.push(deferred);
    }

    checkDistrictNCESValid() {
        let ncesLen = this.schoolDistrictNCES?.toString().length;

        if (ncesLen > 0) {
            if (ncesLen < 7) {
                this.myError = 'School District NCES is 7 characters long.';
                return false;
            } else {
                return true;
            }
        } else {
            console.log('checkdistrictncesvalid returning false');
        }
        return false;
    }

    fnCheckNCESDistrictCode(evt?: Event) {
        this.ncesValid = false;
        this.myError = '';
        this.ncesChecking = true;

        if (!this.schoolDistrictNCES) {
            console.log('nces code had blank inputs');

            this.myError = 'Error checking NCES District Code:  ncesCode was blank for this school.';
            this.ncesValid = false;
        } else {
            this.schoolAPIService.checkDistrictNCES(parseInt(this.schoolDistrictNCES), this.schoolID).subscribe({
                next: (res: any) => {
                    // console.log('ncesCodeCheck returned: ');
                    // console.log(Object.entries(res.msg));
                    setTimeout(() => {
                        if (res.msg['SUCCESS'] == false) {
                            this.myError = 'Error checking nces district Code:' + res.msg['MSG'];
                            this.ncesValid = false;
                            this.ncesChecking = false;
                        } else {
                            this.ncesValid = true;
                            this.ncesChecking = false;
                            this.ncesChecked = true;
                        }
                    }, 2000);
                },
                error: (err: any) => {
                    setTimeout(() => {
                        this.myError = 'Error checking NCES District Code, please try again.';
                        this.ncesValid = false;
                        this.ncesChecking = false;
                    }, 2000);
                }
            });
        }
    }

    checkValid() {
        let retVal: boolean = true;
        retVal = this.checkDistrictNCESValid();
        console.log('checkValid returning:');
        console.log(retVal);
        if (!retVal) {
            this.myError = 'There are errors, please check your input(s).';
        }
        return retVal;
    }

    getFormValidationErrors(form: UntypedFormGroup) {
        if (form) {
            type newObj = { [key: string]: any };

            let res: newObj = {};

            Object.keys(form.controls).forEach((key: string) => {
                if (key.trim() != 'txtErrorMsg') {
                    let controlErrors: ValidationErrors = <UntypedFormControl>form.get(key)!.errors;
                    if (controlErrors != null) {
                        console.log('control errors');
                        console.log(controlErrors);
                        Object.keys(controlErrors).forEach((keyError) => {
                            if (keyError == 'pattern') {
                                console.log('no error');
                            } else {
                                res[key] = keyError;
                                console.log('found errors');
                                console.log('for control');
                                console.log(key);
                                console.log(keyError);
                            }
                        });
                    }
                }
            });
            console.log('getFormValidation errors returning');
            console.log(Object.keys(res).length);
            console.log(res);
            return Object.keys(res).length === 0 ? null : res;
        } else {
            console.log('getFormValidation errors returning null');
            return null;
        }
    }

    onKeyUp(e: any) {
        if (e.srcElement.maxLength === e.srcElement.value.length) {
            e.preventDefault();
        }
    }

    @HostListener('window:keyup', ['$event'])
    onKeyDown(e: any) {
        const pattern = /[0-9\+\-\ ]/;

        // console.log(e.srcElement.id);
        if (e.key) {
            let inputChar = e?.key?.toString();
            if (!pattern.test(inputChar) && !this.utilityService.isValidKeys(e)) {
                // invalid character, prevent input
                console.log('invalid char pressed');
                e.preventDefault();
            } else {
                if (e.srcElement.id == 'schoolDistrictNCES') {
                    this.fnCheckNCESDistrictCode(e);
                }
                if (e.srcElement.id == 'txtSchoolCode') {
                    this.disableCreateButton();
                }
            }
        }
    }

    onKeyDownText(e: any) {
        const pattern = /[A-Za-z\+\-\ ]/; // /[0-9\+\-\ ]/;

        // console.log(e.srcElement.id);
        if (e.key) {
            let inputChar = e?.key?.toString();
            if (!pattern.test(inputChar) && !this.utilityService.isValidKeys(e)) {
                // invalid character, prevent input
                console.log('invalid char pressed');
                e.preventDefault();
            } else {
                if (e.srcElement.id == 'schoolDistrictNCES') {
                    this.fnCheckNCESDistrictCode(e);
                }
            }
        }
    }

    fnTogglePublicOrPrivateSubTypes() {
        this.scValid = false;
        console.log('now checking schoolcode for:' + this.schoolCode + ' and ' + this.schoolID);
        if (!this.schoolCode || !this.schoolID) {
            console.log('had blank inputs');
            var customMsg = '';
            if (!this.schoolCode) {
                customMsg = customMsg + 'schoolCode,';
            }
            if (!this.schoolID) {
                customMsg = customMsg + 'schoolID, ';
            }
            this.myError = 'Error checking School Code:  ' + customMsg + ' was blank for this school.';
            this.scValid = false;
        } else {
            this.schoolAPIService.checkSchoolCode(this.schoolCode, this.schoolID).subscribe({
                next: (res: any) => {
                    console.log('schoolCodeCheck returned: ');
                    console.log(Object.entries(res.msg));
                    if (res.msg['SUCCESS'] == false) {
                        this.myError = 'Error checking School Code:' + res.msg['MSG'];
                        this.scValid = false;
                        this.ngValid = false;
                        this.ngChecking = false;
                    } else {
                        this.scValid = true;
                        this.ngChecking = false;
                        this.ngChecked = true;
                        this.ngValid = true;
                    }
                },
                error: (err: any) => {
                    this.myError = 'Error checking School Code, please try again.';
                    this.scValid = false;
                    this.ngValid = false;
                    this.ngChecking = false;
                }
            });
        }
    }

    fnToggleSubTypes() {
        console.log('isEditable:' + this.isUneditable);
        if (!this.isUneditable) {
            this.bDisAllowSubTypes = false;

            console.log('bAllowSubtypes:' + this.bDisAllowSubTypes);
        }
        console.log('now incrementing iToggleSCValid3');
        // handle radio button
        this.iToggleSCValid3 = this.iToggleSCValid3 + 1;

        if (this.iToggleSCValid3 > 2) {
            this.iToggleSCValid3 = 0;
        }
    }

    showValuePromptText(inStr: string, evt: Event) {
        ///console.log("called showValue:" + inStr + ":" + evt)
        this.myGradeError = '';
        this.fnValidateGrades();
    }

    recheckClosedDate(evt: Event) {
        this.myCloseDateError = '';
        let inCloseDate: string = this.validateClosedDate();
        console.log('inCloseDate check:' + inCloseDate);
    }

    fnSetSaveButton($event: MatTabChangeEvent) {
        var inStr: string = '';
        switch ($event.index) {
            case 0:
                inStr = 'generalinfo';
                break;
            case 1:
                inStr = 'contactinfo';
                break;
            case 2:
                inStr = 'schoollocation';
                break;
            default:
                inStr = 'generalinfo';
                break;
        }
        this.saveButtonToShow = inStr;
    }

    pad(num: number) {
        return ('00' + num).slice(-2);
    }

    fnSaveGeneralInfo(evt: Event) {
        console.log('saving general info');
        this.myError = ''; // this needs to be cleared each time prior to a new save
        var formattedDate;
        // first check grade selection
        if (!this.fnValidateGrades()) {
            console.log('showing error for grades');
            this.myError = 'Low grade cannot be greater than high grade.';
        }

        let inSchoolID: number = this.schoolID; // editSchoolsForm.controls['ID'].value; //this.organizationId; //
        let inOrgId: number = this.organizationId;
        let inSchoolName: string = this.editSchoolsForm.controls['schoolNameFC'].value;
        let inSchoolSSID: string = this.editSchoolsForm.controls['schoolSSID'].value;
        let inCdsCode: string = this.editSchoolsForm.controls['cdsCode'].value;
        //console.log("inCdsCode came in as: " + inCdsCode);

        let inSchoolNCES: string = this.editSchoolsForm.controls['schoolNCES'].value;
        let inRadioSchoolType: string = this.schoolType.toString();
        let inRadioSchoolStatus: string = this.schoolStatus.toString();
        let inSelectSubType: string = this.editSchoolsForm.controls['selectSubType'].value;
        let inSelectLowGrade: string = this.editSchoolsForm.controls['selectLowGrade'].value;
        let inSelectHighGrade: string = this.editSchoolsForm.controls['selectHighGrade'].value;
        //console.log("inSelectLowGrade came in as: " + inSelectLowGrade);
        //console.log("inSelectHighGrade came in as: " + inSelectHighGrade);
        // console.log("inRadioSchoolStatus came in as: " + inRadioSchoolStatus);
        //console.log("inRadioSchoolType came in as: " + inRadioSchoolType);
        //console.log("inSelectSubType came in as: " + inSelectSubType);

        let inCloseDate: string = this.validateClosedDate();

        let inTxtSchoolCode: string = this.editSchoolsForm.controls['txtSchoolCode'].value;
        let inChkSatelliteCampus: string;
        if (this.satelliteCampus) {
            inChkSatelliteCampus = 'true';
        } else {
            inChkSatelliteCampus = 'false';
        }
        //console.log("satelliteCampus will save using:" + inChkSatelliteCampus)

        /* if (inSchoolName) inSchoolName = inSchoolName?.trim();
      if (inSchoolSSID) inSchoolSSID = inSchoolSSID?.trim();
      if (inCdsCode) inCdsCode = inCdsCode?.trim();
      if (inSchoolNCES) inSchoolNCES = inSchoolNCES?.trim();*/
        if (inRadioSchoolType) inRadioSchoolType = inRadioSchoolType?.trim();
        if (inRadioSchoolStatus) inRadioSchoolStatus = inRadioSchoolStatus?.trim();
        if (inSelectSubType) inSelectSubType = inSelectSubType?.trim();
        /* if (inSelectLowGrade) inSelectLowGrade = inSelectLowGrade?.trim();
        if (inSelectHighGrade) inSelectHighGrade = inSelectHighGrade?.trim();*/
        if (inTxtSchoolCode) inTxtSchoolCode = inTxtSchoolCode?.trim();
        if (inChkSatelliteCampus) inChkSatelliteCampus = inChkSatelliteCampus?.trim();
        let editSchool: School = new School();
        if (inSchoolID != null) {
            editSchool.ID = inSchoolID;
            this.school.ID = inSchoolID;
        }
        if (inOrgId != null) {
            editSchool.ORGANIZATIONS_ID = inOrgId;
            this.school.ORGANIZATIONS_ID = inOrgId;
        }
        if (inSchoolName != null) {
            editSchool.NAME = inSchoolName;
            this.school.NAME = inSchoolName;
        }
        if (inSchoolSSID != null) {
            editSchool.SSID = inSchoolSSID;
            this.school.SSID = inSchoolSSID;
        }
        if (inSchoolNCES != null) {
            editSchool.SCHOOL_NCES = inSchoolNCES;
            this.school.SCHOOL_NCES = inSchoolNCES;
        }

        if (inRadioSchoolType != null) {
            //  console.log("now setting inRadioSchoolType:" + inRadioSchoolType)
            editSchool.SCHOOL_TYPE_ID = parseInt(inRadioSchoolType);
            let mySchoolType: SCHOOL_TYPE = new SCHOOL_TYPE();
            mySchoolType.ID = editSchool?.SCHOOL_TYPE_ID;
            this.school.SCHOOL_TYPE = mySchoolType;
            this.school.SCHOOL_TYPE_ID = editSchool?.SCHOOL_TYPE_ID;
        }

        //console.log("now setting inRadioSchoolStatus:");
        //console.log(inRadioSchoolStatus)

        if (inRadioSchoolStatus != null) {
            let mySchoolStatusType: SCHOOL_STATUS_TYPE = new SCHOOL_STATUS_TYPE();
            mySchoolStatusType = this.school?.SCHOOL_STATUS_TYPES;
            mySchoolStatusType.ID = parseInt(inRadioSchoolStatus);
            //console.log("mySchoolStatusType:")
            //console.log(mySchoolStatusType)
            switch (mySchoolStatusType.ID) {
                case 1:
                    mySchoolStatusType.DESCRIPTION = 'Open';
                    break;
                case 2:
                    mySchoolStatusType.DESCRIPTION = 'Close/Merged';
                    break;
            }
            this.school.SCHOOL_STATUS_TYPES = mySchoolStatusType;

            if (this.schoolStatus == 1) {
                // if it is an open school , blank out the closed date
                this.closedDate = '';
            }
        }

        //console.log("inSelectSubType:")
        //console.log(inSelectSubType)

        if (inSelectSubType) {
            let mySchoolType: SCHOOL_TYPE = new SCHOOL_TYPE();
            mySchoolType = this.school.SCHOOL_TYPE;
            //console.log(mySchoolType);
            if (mySchoolType) {
                //console.log(Object.entries(this.subTypeItems))
                //  console.log("checking subTypeItems:")
                //  console.log(this.subTypeItems)
                let myInd: number = this.subTypeItems.findIndex((x) => x.ID == parseInt(inSelectSubType));
                //  console.log("myInd:" + myInd)
                mySchoolType.ID = parseInt(inSelectSubType);
                if (this.subTypeItems[myInd].DESCRIPTION != undefined) {
                    mySchoolType.DESCRIPTION = this.subTypeItems[myInd].DESCRIPTION;
                }
                mySchoolType.CREATED_BY = this.subTypeItems[myInd].CREATED_BY;
                mySchoolType.CREATED_DATE = this.subTypeItems[myInd].CREATED_DATE;
                mySchoolType.IS_OTHER_TYPE = this.subTypeItems[myInd].IS_OTHER_TYPE;
                mySchoolType.MODIFIED_BY = this.subTypeItems[myInd].MODIFIED_BY;
                mySchoolType.MODIFIED_DATE = this.subTypeItems[myInd].MODIFIED_DATE;
                mySchoolType.OTHER_ID = this.subTypeItems[myInd].OTHER_ID;
                mySchoolType.TYPE = this.subTypeItems[myInd].TYPE;

                editSchool.SCHOOL_TYPE_OTHERS = mySchoolType;
                this.school.SCHOOL_TYPE_OTHERS = mySchoolType;
            }
        }
        if (inSelectLowGrade != null) {
            editSchool.LOW_GRADE = parseInt(inSelectLowGrade);
            this.school.LOW_GRADE = this.gradeSpanLow;
            const thisGrade: any = this.gradeItems.find(({ ID }) => ID === this.gradeSpanLow);
            this.school.LOW_GRADES = thisGrade;
        }
        if (inSelectHighGrade != null) {
            editSchool.HIGH_GRADE = parseInt(inSelectHighGrade);
            this.school.HIGH_GRADE = this.gradeSpanHigh;
            const thisGrade: any = this.gradeItems.find(({ ID }) => ID === this.gradeSpanHigh);
            this.school.HIGH_GRADES = thisGrade;
        }
        if (inTxtSchoolCode != null) {
            editSchool.SCHOOL_CODE = parseInt(inTxtSchoolCode);
            this.school.SCHOOL_CODE = editSchool.SCHOOL_CODE;
        }
        if (inChkSatelliteCampus != null) {
            //console.log("satellite campus:")
            //console.log(this.satelliteCampus)
            this.myPropType = new SCHOOL_PROPERTY_TYPE();
            this.myPropType.ID = this.satelliteCampus ? 1 : 2;
            if (this.myPropType.ID == 2) {
                this.myPropType.TYPE = 'Regular';
            } else {
                this.myPropType.TYPE = 'Satellite Campus';
            }
            //console.log("now setting inChkSatelliteCampus:" + this.myPropType.ID)
            editSchool.SCHOOL_PROPERTY_TYPES = this.myPropType;
            this.school.SCHOOL_PROPERTY_TYPES = editSchool.SCHOOL_PROPERTY_TYPES;
        }
        // console.log("about to save closedate")
        if (inCloseDate != null) {
            var cleanDate = new Date(inCloseDate);
            var inDate = new Date();
            //editSchool.CLOSE_DATE = cleanDate.getTime().toString();
            
            inDate = new Date(
                moment().format(
                    cleanDate.getFullYear() +
                        '-' +
                        this.pad(cleanDate.getMonth() + 1) +
                        '-' +
                        this.pad(cleanDate.getDate()) +
                        ' ' +
                        this.pad(cleanDate.getHours()) +
                        ':' +
                        this.pad(cleanDate.getMinutes()) +
                        ':' +
                        this.pad(cleanDate.getSeconds())
                )
            );
            this.mySchoolStatus.CLOSE_DATE = inDate; 
            this.school.CLOSE_DATE = inDate;
            this.mySchoolStatus.CLOSE_DATE = inDate;
            this.school.SCHOOL_STATUS = this.mySchoolStatus;
            console.log("cleaned date was: " + inDate)
        }

        Swal.fire({
            title: 'Are you sure you want to save?',
            showDenyButton: false,
            showConfirmButton: true,
            showCancelButton: true,
            denyButtonText: ``
        }).then((result) => {
            if (result.isConfirmed && this.myError == '' && this.myGradeError == '' && this.myCloseDateError == '') {
                this.schoolAPIService.updateSchoolGeneralInfo(this.school).subscribe({
                    next: (res: any) => {
                        //console.log("checking api res message:")
                        //console.log(res)
                        //console.log(res.editSchool)
                        if (!res.msg['SUCCESS']) {
                            this.isUneditable = false;
                            this.bCancelEdit = true;
                            this.myError = res.msg['MSG'];
                        } else {
                            this.isUneditable = true;
                            this.bCancelEdit = false;
                            this.editBtnText = 'Edit';
                            this.bAllowSC = false;
                           formattedDate = cleanDate.toLocaleDateString('en-US', { // now update the display with the proper date format otherwise it gets blanked to nothing after saving!
                                month: '2-digit',
                                day: '2-digit',
                                year: 'numeric'
                              });
                            /*const parsedDate = new Date(formattedDate);
                            this.editSchoolsForm.get('frmCloseDate')?.setValue(parsedDate.toString());
                            console.log("override set: " + parsedDate.toString());*/
                            this.fnSetInitialData();
                        }
                    },
                    error: (err: any) => {
                        console.log('error while updating school data: ' + Object.entries(err));
                    }
                });
            } else {
                console.log('errored out so we are not saving');
            }
        });
    }

    fnSaveContactInfo() {
        console.log('saving contact info');
        //var inSchoolName = this.editSchoolsForm.controls['schoolName'].value;

        /*The saves here are done via contact mech saves! so we can just say like Save completed.*/
        Swal.fire({
            title: 'Are you sure you want to save?',
            showDenyButton: false,
            showConfirmButton: true,
            showCancelButton: true,
            denyButtonText: ``
        }).then((result) => {
            if (result.isConfirmed) {
                let params: any;

                console.log('saving partyContactMechanisms:');
                console.log(Object.entries(this.partyContactMechanisms));
                console.log('saving deletePartyContactMechansmis: ');
                console.log(Object.entries(this.deletePartyContactMechanisms));
                // clean created dates
                /* this.cleanedCreatedDate = new FormControl(moment());
         console.log("cleanedCreatedDate:" + Object.entries(this.cleanedCreatedDate))
 
         this.partyContactMechanisms.forEach(partyContact =>{
           console.log("parsing partyContact")
           console.log(partyContact)
           if (partyContact)
           {
             partyContact['CREATED_DATE'] =  <Date>(new CleanDatePipe().transform(partyContact?['CREATED_DATE']));
             console.log(partyContact['CREATED_DATE'])
             if (this.cleanedCreatedDate)
             {
               let cleanDate:Date = new Date( partyContact['CREATED_DATE'] );
               console.log("created date from : " + cleanDate.getTime());
               if ((cleanDate.getTime() == -62135596800000) || (cleanDate.getTime().toString() == 'NaN')) // invalid date
               {
               }
               else {
                 this.cleanedCreatedDate = new FormControl(moment([cleanDate.getFullYear(), cleanDate.getMonth(), cleanDate.getDay()]));// .setValue(cleanDate);
                 console.log("cleanedCreatedDate is now:" + Object.entries(this.cleanedCreatedDate))
               }
             }
         }        
         })
       */

                params = {
                    editSchool: this.school,
                    partyContactMechanisms: this.partyContactMechanisms,
                    deletePartyContactMechanisms: this.deletePartyContactMechanisms
                };
                this.schoolAPIService.updateSchoolContactInfo(params).subscribe({
                    next: (res: any) => {
                        this.isUneditable = true;
                        this.bCancelEdit = false;
                        this.editBtnText = 'Edit';
                    },
                    error: (err: any) => {
                        console.log('error while updating school data: ' + Object.entries(err));
                    }
                });

                this.schoolAPIService.updateSchoolGeneralInfo(this.school).subscribe({
                    next: (res: any) => {
                        this.isUneditable = true;
                        this.bCancelEdit = false;
                        this.editBtnText = 'Edit';
                    },
                    error: (err: any) => {
                        console.log('error while updating school data: ' + Object.entries(err));
                    }
                });
            }
        });
    }

    fnSaveSchoolLocation() {
        console.log('saving school location');

        if (this.checkValid()) {
            let inSchoolDistrictNCES: string = this.schoolDistrictNCES || '';

            var editRegion: any;
            editRegion = this.chosenRegions[0];

            var editCounty: any;
            editCounty = this.chosenCounties[0];

            var editDistrict: any;
            editDistrict = this.chosenSchoolDistricts[0];

            Swal.fire({
                title: 'Are you sure you want to save?',
                showDenyButton: false,
                showConfirmButton: true,
                showCancelButton: true,
                denyButtonText: ``
            }).then((result) => {
                if (result.isConfirmed) {
                    let params: any;

                    this.school.REGION = editRegion['CODE'];
                    this.school.REGIONS = editRegion;

                    let iContactMechIndex = 0;
                    this.school.ORGANIZATION.PARTy.PARTY_CONTACT_MECHANISMS.forEach((contactMech: ContactMechanisms) => {
                        let myPostalAddress: POSTAL_ADDRESSES;

                        iContactMechIndex = iContactMechIndex + 1;

                        if (contactMech.POSTAL_ADDRESSES) {
                            myPostalAddress = contactMech.POSTAL_ADDRESSES;
                            myPostalAddress.GEOGRAPHICAL_REGIONS_ID = editRegion;
                            let myGeographicalRegion: GEOGRAPHICAL_REGIONS;
                            myGeographicalRegion = myPostalAddress.GEOGRAPHICAL_REGIONS;
                            myGeographicalRegion.REGION = editRegion;
                            myPostalAddress.GEOGRAPHICAL_REGIONS = myGeographicalRegion;
                            contactMech.POSTAL_ADDRESSES = myPostalAddress;
                        }
                    });
                    this.school.COUNTy = editCounty;
                    this.countiesSelected([this.school.COUNTy]);
                    this.school.SCHOOL_DISTRICT = editDistrict;
                    this.districtsSelected = editDistrict;

                    this.school.SCHOOL_DISTRICT = editDistrict;

                    // set back school district nces after it was reset by selecting county/district
                    this.schoolDistrictNCES = inSchoolDistrictNCES;

                    console.log('backup being saved:');
                    console.log(this.schoolBackup);
                    let data: any;
                    data = {
                        editSchool: this.school,
                        schoolBackup: this.schoolBackup
                    };

                    this.schoolAPIService
                        .updateSchoolLocation(data) // , this.school, this.schoolBackup
                        .subscribe({
                            next: (res: any) => {
                                this.isUneditable = true;
                                this.bCancelEdit = false;
                                this.editBtnText = 'Edit';
                                console.log('save done');
                            },
                            error: (err: any) => {
                                console.log('error while updating school data: ' + Object.entries(err));
                            }
                        });
                }
            });
        }
    }

    getSpecificDistrict(id: number): SchoolDistrict | null {
        for (var i = 0; i < this.allSchoolDistricts.length; i++) {
            if (this.allSchoolDistricts[i].ID == id) {
                return this.allSchoolDistricts[i];
            }
        }
        return null;
    }

    getSpecificRegion(id: number): Region | null {
        for (var i = 0; i < this.allSchoolRegions.length; i++) {
            if (this.allSchoolRegions[i].ID) {
                if (this.allSchoolRegions[i].ID == id) {
                    return this.allSchoolRegions[i];
                }
            }
        }
        return null;
    }

    getSpecificCounty(id: number): County | null {
        for (var i = 0; i < this.allSchoolCounties.length; i++) {
            if (this.allSchoolCounties[i].ID == id) {
                return this.allSchoolCounties[i];
            }
        }
        return null;
    }

    addEvent(type: string, event: any) {
        console.log('now changing date day');
        this.events.push(`${type}: ${event}`);
    }

    fnClickDateToday() {
        this.serializedDate = new UntypedFormControl(new Date().toISOString());
    }

    fnClearDateField() {
        this.editSchoolsForm.controls['frmCloseDate'].setValue('');
        this.closedDate = '';
        console.log('now rechecking closed date');
        let inCloseDate: string = this.validateClosedDate();
    }

    fnFigureRadioSchoolChecked(evt: Event, opId: number, schoolType: number): boolean {
        // console.log("calling fnFigureRadioSchoolChecked for " + opId)
        let bRet: boolean = true;
        if (!this.isUneditable) {
            switch (opId) {
                case 1:
                    this.fnToggleAndCheck(1);
                    this.bDisAllowSubTypes = true;
                    this.schoolType = 1;
                    if (this.radioOptionsSchoolType['0'].checked == true) {
                        this.bAllowSC = true;
                        this.bCheckedSCCode1 = true;
                        this.schoolType = 1;
                        this.scValid = true;
                        this.radioOptionsSchoolType['1'].checked = false;
                        this.radioOptionsSchoolType['2'].checked = false;
                        this.iToggleSCValid2 = 0;
                        this.iToggleSCValid3 = 0;
                        this.bCheckedSCCode2 = false;
                        this.bCheckedSCCode3 = false;
                        //evt.preventDefault(); // this is JUST for preventing radio button from showing true or false, i.e. show blank
                    } else {
                        this.bCheckedSCCode1 = false;
                        this.bAllowSC = false;
                    }
                    break;
                case 2:
                    this.bDisAllowSubTypes = true;
                    this.fnToggleAndCheck(2);
                    this.schoolType = 2;
                    if (this.radioOptionsSchoolType['1'].checked == true) {
                        this.bAllowSC = true;
                        this.bCheckedSCCode2 = true;
                        this.schoolType = 2;
                        this.scValid = true;
                        this.radioOptionsSchoolType['0'].checked = false;
                        this.radioOptionsSchoolType['2'].checked = false;
                        this.iToggleSCValid1 = 0;
                        this.iToggleSCValid3 = 0;
                        this.bCheckedSCCode1 = false;
                        this.bCheckedSCCode3 = false;
                        //evt.preventDefault(); // this is JUST for preventing radio button from showing true or false, i.e. show blank
                    } else {
                        this.bCheckedSCCode2 = false;
                        this.bAllowSC = false;
                    }
                    break;
                case 3:
                    this.bAllowSC = false;
                    this.fnToggleAndCheck(3);
                    this.schoolType = 3;
                    if (this.radioOptionsSchoolType['2'].checked == true) {
                        this.bCheckedSCCode3 = true;
                        this.schoolType = 3;
                        this.bDisAllowSubTypes = false;
                        this.scValid = true;
                        this.radioOptionsSchoolType['0'].checked = false;
                        this.radioOptionsSchoolType['1'].checked = false;
                        this.iToggleSCValid1 = 0;
                        this.iToggleSCValid2 = 0;
                        this.bCheckedSCCode1 = false;
                        this.bCheckedSCCode2 = false;
                      //  evt.preventDefault(); // this is JUST for preventing radio button from showing true or false, i.e. show blank
                    } else {
                        this.bCheckedSCCode3 = false;
                        this.bDisAllowSubTypes = true;
                    }
                    break;
            }
        }
        return bRet;
    }

    fnFigureRadioSchoolStatusChecked(evt: Event, opId: number): boolean {
        if (!this.isUneditable) {
            this.schoolStatus = opId;
            //console.log("fnFigureRadioSchoolStatusChecked setting radio to:")
            //console.log(opId);
        }
        return true;
    }

    fnToggleAndCheck(
        btnNum: number // toggles the radio button to second state and back
    ) {
        // radio buttons for school type are: 1, 2, 3, but their radioOptionsSchoolType tags are 1 less, i.e. 0, 1, 2
        switch (btnNum) {
            case 1:
                this.iToggleSCValid1 = this.iToggleSCValid1 + 1;
                if (this.iToggleSCValid1 > 1) {
                    this.radioOptionsSchoolType['0'].checked = !this.radioOptionsSchoolType['0'].checked;
                    this.iToggleSCValid1 = 0;
                } else {
                    this.radioOptionsSchoolType['0'].checked = true;
                }
                break;

            case 2:
                this.iToggleSCValid2 = this.iToggleSCValid2 + 1;
                if (this.iToggleSCValid2 > 1) {
                    this.radioOptionsSchoolType['1'].checked = !this.radioOptionsSchoolType['1'].checked;
                    this.iToggleSCValid2 = 0;
                } else {
                    this.radioOptionsSchoolType['1'].checked = true;
                }
                break;
            case 3:
                this.iToggleSCValid3 = this.iToggleSCValid3 + 1;
                if (this.iToggleSCValid3 > 1) {
                    this.radioOptionsSchoolType['2'].checked = !this.radioOptionsSchoolType['2'].checked;
                    this.iToggleSCValid3 = 0;
                } else {
                    this.radioOptionsSchoolType['2'].checked = true;
                }
                break;
        }
    }

    valueChkChange($event: any) {
        this.satelliteCampus = $event.checked;
    }

    fnIsEditingContactMechChange($event: any) {
        console.log('calling fnEditingContactMechChange with:' + Object.entries($event));
        var mechEntries = Object.entries($event);
        console.log('len:' + mechEntries.length);
        if (mechEntries.length > 0) {
            mechEntries.forEach((x) => console.log('herea' + Object.entries(x)));
            console.log('herea:' + Object.entries(mechEntries[1]));
        }
    }

    fnPartyEditingContactMechChange($event: any) {
        console.log('calling PartyEditingContactMechChange with:');
        console.log(Object.entries($event));
        let mechEntries: PartyContactMechanisms[] = [];
        mechEntries.push(<PartyContactMechanisms>Object.entries($event)[0]);
        console.log('orig mech entries len:' + mechEntries.length);
        if (mechEntries.length > 0) {
            let i: number = 0;
            mechEntries.forEach((mechEntry) => {
                let grabPartyContactMechID: number = this.school.ORGANIZATION.PARTy['PARTY_CONTACT_MECHANISMS'][i].ID;
                mechEntry.ID = grabPartyContactMechID;
                console.log('mechEntry created_date:');
                console.log(mechEntry.CREATED_DATE);
                if (mechEntry.CREATED_DATE) {
                    let cleanDateStr: string = '';
                    cleanDateStr = new CleanDatePipe().transform(mechEntry.CREATED_DATE);
                    var cleanDate = new Date(cleanDateStr);
                    console.log('setting cleaned created_date :' + cleanDate);
                    mechEntry.CREATED_DATE = cleanDate;
                } else if (mechEntry.MODIFIED_DATE) {
                    let cleanDateStr: string = '';
                    cleanDateStr = new CleanDatePipe().transform(mechEntry.MODIFIED_DATE);
                    var cleanDate = new Date(cleanDateStr);
                    console.log('setting cleaned modified_date :' + cleanDate);
                    mechEntry.MODIFIED_DATE = cleanDate;
                }
                // console.log('setting a mech id to:' + mechEntry.ID);
                // console.log(mechEntry);
                i = i + 1;
            });

            // set these changes to partyContactMechanisms object
            console.log('saving to partyContactMechanism object:' + mechEntries);

            var whatToPassToContactMech = mechEntries[0];
            const whatToPassObj: PartyContactMechanisms[] = <PartyContactMechanisms[]>whatToPassToContactMech;
            //  console.log(whatToPassObj);

            const whatToPassObj2: PartyContactMechanisms[] = <PartyContactMechanisms[]>whatToPassObj[1];
            // console.log(whatToPassObj2);

            this.partyContactMechanisms = whatToPassObj2;
            // console.log('curlen before change:' + this.partyContactMechanisms.length);
            // console.log(Object.entries(this.partyContactMechanisms));
        }
    }

    openDialog() {
        console.log('sending this date to custom cal:' + this.closedDate);
        const dialogRef = this.dialog.open(CustomDatepickerComponent, {
            panelClass: 'custom-dialog-container',
            width: '24%',
            height: '50%',
            data: { selectedDate: this.closedDate }
        });
        dialogRef.afterClosed().subscribe((result) => {
            console.log('now resetting selected calendar date');
            console.log('result incoming:');
            console.log(result);
            if (result?.myResult) {
                console.log("first branch")
                this.closedDate = result.myResult ? new CleanDatePipe().transform(result.myResult) 
                : '';         
            }
            if (result?.event) {
                console.log("second branch")
                if (result?.event == 'clear') {
                    console.log("third branch")
                    this.closedDate = '';
                }
            }
            //this.ngOnInit();
        });
    }

    disableCreateButton() {
        let inSchoolName: string = this.schoolName;

        let inSchoolNCES: string = this.NCES;
        let inSchoolType: number = this.schoolType;
        let inSchoolStatus: number = this.schoolStatus;
        let inSchoolCodeFC: string = this.schoolCode.toString();

        // let inSchoolCode: string = this?.value;

        /*    console.log("school name check")
            console.log(inSchoolName)
            console.log("schoolType check:")
            console.log(inSchoolType)
            console.log("inSchoolType:");
            console.log(inSchoolType);
            console.log("inSchoolStatus:");
            console.log(inSchoolStatus);
            console.log("inSchoolCodeFC:");
            console.log(inSchoolCodeFC);            
        */
        if (
            /*(inRegions?.length > 0) &&
            (inCounties?.length > 0) &&
            (inDistricts?.length > 0) &&*/
            inSchoolName?.length > 0 &&
            inSchoolType > 0 &&
            inSchoolStatus > 0 &&
            inSchoolCodeFC?.length > 0
        ) {
            this.bDisableCreateButton = false;
            return false;
        }

        /*    console.log("missing one required field:");
            (!inSchoolName) ? console.log("N-inSchoolName") : '';
            (!inSchoolNCES) ? console.log("N-inSchoolNCES") : '';
            (!inSchoolType) ? console.log("N-inSchoolType") : '';
            (!inSchoolStatus) ? console.log("N-inSchoolStatus") : '';
            (!inSchoolCodeFC) ?  console.log("N-inSchoolCodeFC") : '';
        */
        this.bDisableCreateButton = true;
        return true;
    }

    disableCreateButton2() {
        this.bDisableCreateButton2 = false;
        return false;
    }

    disableCreateButton3() {
        let inRegions: string = this.child2?.selectedRegionIds?.toString();
        let inCounties: string = this.child3?.selectedCountyIds?.toString();
        let inDistricts: string = this.child?.selectedSchoolDistrictIds?.toString();
        let inSchoolDistrictNCES: string = this.schoolDistrictNCES; // this.schoolDistrictNcesFC?.value;

        // let inSchoolCode: string = this?.value;

        console.log('school district nces check:');
        console.log(inSchoolDistrictNCES);
        console.log('inRegions:');
        console.log(inRegions);
        console.log('inCOunties:');
        console.log(inCounties);
        console.log('inDistricts');
        console.log(inDistricts);
        console.log('inSchoolDistrictNCES');
        console.log(inSchoolDistrictNCES);
        console.log(inSchoolDistrictNCES.length);
        console.log(inSchoolDistrictNCES?.length);

        if (
            inRegions?.length > 0 &&
            inCounties?.length > 0 &&
            /* (inDistricts?.length > 0) && */
            inSchoolDistrictNCES?.length > 0
        ) {
            this.bDisableCreateButton3 = false;
            return false;
        }

        console.log('missing one required field:');
        !inRegions ? console.log('N-inRegions') : '';
        !inCounties ? console.log('N-inCounties') : '';
        !inDistricts ? console.log('N-inDistricts') : '';
        !inDistricts ? console.log('N-inDistricts') : '';
        !inSchoolDistrictNCES ? console.log('N-inSchoolDistrictNCES') : '';

        this.bDisableCreateButton3 = true;
        return true;
    }
}
